module.exports = __webpack_public_path__ + "img/thumb-rusiandi.1792a13c.jpg";